import { action, makeAutoObservable, observable } from 'mobx';

export class LoaderStore {
	private _loadingCount = 0;

	constructor() {
		makeAutoObservable<LoaderStore, '_loadingCount'>(this, {
			_loadingCount: observable,
			increaseLoadingCount: action,
			decreaseLoadingCount: action,
		});
	}

	get isLoading() {
		return this._loadingCount > 0;
	}

	public increaseLoadingCount() {
		this._loadingCount += 1;
	}

	public decreaseLoadingCount() {
		this._loadingCount -= 1;
	}
}
